import { useState, useEffect } from "react";

const LuckySpinPage = () => {
  const [currentPage, setCurrentPage] = useState<"start" | "login" | "register" | "main" | "reset" | "admin">("start");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loggedInUser, setLoggedInUser] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [result, setResult] = useState<{ number: number; prize: string } | null>(null);
  const [userBalance, setUserBalance] = useState("0.00000000");
  const [refCount, setRefCount] = useState(0);
  const [refComissao, setRefComissao] = useState("0.00000000");
  const [resetUsername, setResetUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const showLogin = () => setCurrentPage("login");
  const showRegister = () => setCurrentPage("register");
  const showReset = () => setCurrentPage("reset");
  const goBack = () => setCurrentPage("start");

  const register = () => {
    if (!username || !password) {
      alert("Preencha os campos!");
      return;
    }

    const storedUser = localStorage.getItem(username);
    if (storedUser) {
      alert("Usuário já existe.");
    } else {
      localStorage.setItem(username, password);
      alert("Conta criada! Faça login.");
      goBack();
    }
  };

  const login = () => {
    const storedPassword = localStorage.getItem(username);
    if (storedPassword && storedPassword === password) {
      setLoggedInUser(username);
      setCurrentPage("main");
      updateBalance();
      
      // Verificar referência na URL
      const ref = getRefFromURL();
      if (ref) salvarIndicado(ref);
      
      // Atualizar informações de referência
      setTimeout(atualizarReferencias, 100);
    } else {
      alert("Usuário ou senha incorretos.");
    }
  };
  
  useEffect(() => {
    if (loggedInUser) {
      updateBalance();
      atualizarReferencias();
    }
  }, [loggedInUser]);
  
  const updateBalance = () => {
    const saldo = localStorage.getItem(loggedInUser + "_saldo") || "0.00000000";
    setUserBalance(saldo);
  };
  
  const getRefFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('ref');
  };
  
  const salvarIndicado = (referenciador: string) => {
    const indicados = JSON.parse(localStorage.getItem(referenciador + "_indicados") || "[]");
    if (!indicados.includes(loggedInUser) && loggedInUser !== referenciador) {
      indicados.push(loggedInUser);
      localStorage.setItem(referenciador + "_indicados", JSON.stringify(indicados));
      localStorage.setItem(loggedInUser + "_referencia", referenciador);
    }
  };
  
  const atualizarReferencias = () => {
    if (!loggedInUser) return;
    
    const refLink = `${window.location.origin}${window.location.pathname}?ref=${loggedInUser}`;
    const refLinkElement = document.getElementById("refLink");
    if (refLinkElement) refLinkElement.innerText = refLink;
    
    const indicados = JSON.parse(localStorage.getItem(loggedInUser + "_indicados") || "[]");
    setRefCount(indicados.length);
    
    const comissao = localStorage.getItem(loggedInUser + "_comissao") || "0.00000000";
    setRefComissao(comissao);
  };

  const spin = () => {
    if (!walletAddress) {
      alert("Digite sua carteira BTC.");
      return;
    }

    const num = Math.floor(Math.random() * 10001);
    let prizeAmount = 0.00000002;

    if (num >= 9886 && num <= 9985) prizeAmount = 0.00000024;
    else if (num >= 9986 && num <= 9993) prizeAmount = 0.00000236;
    else if (num >= 9994 && num <= 9997) prizeAmount = 0.00002364;
    else if (num >= 9998 && num <= 9999) prizeAmount = 0.00023640;
    else if (num === 10000) prizeAmount = 0.00236395;

    const prize = prizeAmount.toFixed(8) + " BTC";
    setResult({ number: num, prize });
    
    // Atualizar saldo do usuário
    const saldoAtual = parseFloat(localStorage.getItem(loggedInUser + "_saldo") || "0");
    const novoSaldo = (saldoAtual + prizeAmount).toFixed(8);
    localStorage.setItem(loggedInUser + "_saldo", novoSaldo);
    updateBalance();
    
    // COMISSÃO PARA O REFERENCIADOR
    const referenciador = localStorage.getItem(loggedInUser + "_referencia");
    if (referenciador) {
      const comissao = (prizeAmount * 0.05).toFixed(8); // 5% de comissão
      const saldoAtual = parseFloat(localStorage.getItem(referenciador + "_comissao") || "0");
      const novoSaldo = (saldoAtual + parseFloat(comissao)).toFixed(8);
      localStorage.setItem(referenciador + "_comissao", novoSaldo);
    }
  };
  
  const solicitarSaque = () => {
    const saldo = parseFloat(userBalance);
    if (saldo < 0.0001) {
      alert("Saldo insuficiente. Mínimo para saque: 0.0001 BTC");
      return;
    }

    if (!walletAddress) {
      alert("Insira sua carteira BTC para sacar.");
      return;
    }

    alert(`Pedido de saque enviado com sucesso!\nUsuário: ${loggedInUser}\nValor: ${userBalance} BTC\nCarteira: ${walletAddress}`);

    // Grava histórico do saque (para admin depois)
    const historico = JSON.parse(localStorage.getItem("saques") || "[]");
    historico.push({
      usuario: loggedInUser,
      valor: userBalance,
      carteira: walletAddress,
      data: new Date().toLocaleString()
    });
    localStorage.setItem("saques", JSON.stringify(historico));

    // Zera saldo após saque
    localStorage.setItem(loggedInUser + "_saldo", "0.00000000");
    updateBalance();
  };
  
  const abrirAdmin = () => {
    setCurrentPage("admin");
    carregarSaques();
  };
  
  const voltarAdmin = () => {
    setCurrentPage("main");
  };
  
  const carregarSaques = () => {
    const historico = JSON.parse(localStorage.getItem("saques") || "[]");
    const adminSaqueList = document.getElementById("adminSaqueList");
    
    if (adminSaqueList) {
      adminSaqueList.innerHTML = "";
      
      historico.forEach(saque => {
        const row = document.createElement("tr");
        row.innerHTML = `
          <td>${saque.usuario}</td>
          <td>${saque.valor}</td>
          <td>${saque.carteira}</td>
          <td>${saque.data}</td>
        `;
        adminSaqueList.appendChild(row);
      });
    }
  };
  
  const resetarSenha = () => {
    const user = resetUsername;
    const novaSenha = newPassword;
    
    if (!localStorage.getItem(user)) {
      alert("Usuário não encontrado.");
      return;
    }
    
    localStorage.setItem(user, novaSenha);
    alert("Senha redefinida com sucesso!");
    goBack();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0f0f0f] to-[#1e1e1e] font-['Orbitron'] text-[#00ffea] text-center p-8">
      {currentPage === "start" && (
        <div>
          <h1 className="text-4xl text-[#ff00c8] drop-shadow-[0_0_10px_#ff00c8] mb-6">LuckySpin BTC</h1>
          <p className="mb-6">Escolha uma opção para continuar:</p>
          <button 
            className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mx-2"
            onClick={showLogin}
          >
            Entrar
          </button>
          <button 
            className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mx-2"
            onClick={showRegister}
          >
            Cadastrar
          </button>
        </div>
      )}

      {currentPage === "register" && (
        <div>
          <h2 className="text-3xl text-[#ff00c8] drop-shadow-[0_0_10px_#ff00c8] mb-6">Cadastrar Conta</h2>
          <input 
            type="text" 
            placeholder="Usuário" 
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="p-2.5 m-2.5 w-64 rounded bg-[#1a1a1a] text-[#00ffea] border-none"
          /><br/>
          <input 
            type="password" 
            placeholder="Senha" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="p-2.5 m-2.5 w-64 rounded bg-[#1a1a1a] text-[#00ffea] border-none"
          /><br/>
          <button 
            className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mx-2 mt-2"
            onClick={register}
          >
            Criar Conta
          </button>
          <button 
            className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mx-2 mt-2"
            onClick={goBack}
          >
            Voltar
          </button>
        </div>
      )}

      {currentPage === "login" && (
        <div id="loginPage">
          <h2 className="text-3xl text-[#ff00c8] drop-shadow-[0_0_10px_#ff00c8] mb-6">Login</h2>
          <input 
            type="text" 
            placeholder="Usuário" 
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="p-2.5 m-2.5 w-64 rounded bg-[#1a1a1a] text-[#00ffea] border-none"
          /><br/>
          <input 
            type="password" 
            placeholder="Senha" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="p-2.5 m-2.5 w-64 rounded bg-[#1a1a1a] text-[#00ffea] border-none"
          /><br/>
          <button 
            className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mx-2 mt-2"
            onClick={login}
          >
            Entrar
          </button>
          <button 
            className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mx-2 mt-2"
            onClick={goBack}
          >
            Voltar
          </button>
          <br/>
          <button 
            className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mx-2 mt-4"
            onClick={showReset}
          >
            Esqueci minha senha
          </button>
        </div>
      )}

      {currentPage === "reset" && (
        <div id="resetPage">
          <h2 className="text-3xl text-[#ff00c8] drop-shadow-[0_0_10px_#ff00c8] mb-6">Redefinir Senha</h2>
          <input 
            id="resetUsername"
            type="text" 
            placeholder="Usuário cadastrado" 
            value={resetUsername}
            onChange={(e) => setResetUsername(e.target.value)}
            className="p-2.5 m-2.5 w-64 rounded bg-[#1a1a1a] text-[#00ffea] border-none"
          /><br/>
          <input 
            id="newPassword"
            type="password" 
            placeholder="Nova Senha" 
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="p-2.5 m-2.5 w-64 rounded bg-[#1a1a1a] text-[#00ffea] border-none"
          /><br/>
          <button 
            className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mx-2 mt-2"
            onClick={resetarSenha}
          >
            Salvar Nova Senha
          </button>
          <button 
            className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mx-2 mt-2"
            onClick={goBack}
          >
            Voltar
          </button>
        </div>
      )}
      
      {currentPage === "admin" && (
        <div id="adminPanel">
          <h2 className="text-3xl text-[#ff00c8] drop-shadow-[0_0_10px_#ff00c8] mb-4">📋 Painel de Admin – Pedidos de Saque</h2>
          <button 
            className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mx-2 mt-2 mb-4"
            onClick={voltarAdmin}
          >
            Fechar Painel
          </button>
          <table className="mx-auto my-5 border-collapse w-4/5 text-[#00ffea] bg-black/50">
            <thead>
              <tr>
                <th className="border border-[#333] p-2.5">Usuário</th>
                <th className="border border-[#333] p-2.5">Valor (BTC)</th>
                <th className="border border-[#333] p-2.5">Carteira</th>
                <th className="border border-[#333] p-2.5">Data/Hora</th>
              </tr>
            </thead>
            <tbody id="adminSaqueList"></tbody>
          </table>
        </div>
      )}
      
      {currentPage === "main" && (
        <div>
          <h2 className="text-3xl text-[#ff00c8] drop-shadow-[0_0_10px_#ff00c8] mb-4">
            Bem-vindo, <span>{loggedInUser}</span>!
          </h2>
          <h3 className="text-2xl text-[#ff00c8] drop-shadow-[0_0_10px_#ff00c8] mb-4">Tabela de Pagamento</h3>
          <table className="mx-auto my-5 border-collapse w-4/5 text-[#00ffea] bg-black/50">
            <thead>
              <tr>
                <th className="border border-[#333] p-2.5">Lucky Number</th>
                <th className="border border-[#333] p-2.5">Prêmio (BTC)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-[#333] p-2.5">0 - 9885</td>
                <td className="border border-[#333] p-2.5">0.00000002 BTC</td>
              </tr>
              <tr>
                <td className="border border-[#333] p-2.5">9886 - 9985</td>
                <td className="border border-[#333] p-2.5">0.00000024 BTC</td>
              </tr>
              <tr>
                <td className="border border-[#333] p-2.5">9986 - 9993</td>
                <td className="border border-[#333] p-2.5">0.00000236 BTC</td>
              </tr>
              <tr>
                <td className="border border-[#333] p-2.5">9994 - 9997</td>
                <td className="border border-[#333] p-2.5">0.00002364 BTC</td>
              </tr>
              <tr>
                <td className="border border-[#333] p-2.5">9998 - 9999</td>
                <td className="border border-[#333] p-2.5">0.00023640 BTC</td>
              </tr>
              <tr>
                <td className="border border-[#333] p-2.5">10000</td>
                <td className="border border-[#333] p-2.5">0.00236395 BTC</td>
              </tr>
            </tbody>
          </table>
          <input 
            type="text" 
            placeholder="Sua carteira BTC" 
            value={walletAddress}
            onChange={(e) => setWalletAddress(e.target.value)}
            className="p-2.5 m-2.5 w-64 rounded bg-[#1a1a1a] text-[#00ffea] border-none"
          /><br/>
          <div id="saldoArea" className="my-4 p-4 bg-black/30 rounded-lg inline-block">
            <p className="text-[#00ffea] mb-2">💰 Seu saldo: <span id="userBalance">{userBalance}</span> BTC</p>
            <p className="text-[#00ffea] mb-2"><strong>📌 Saque mínimo: 0.0001 BTC</strong> – pagamentos enviados manualmente toda sexta-feira!</p>
            <button 
              className="bg-[#ff00c8] text-white px-6 py-2 rounded-full text-sm cursor-pointer shadow-[0_0_8px_#ff00c8] transition-transform duration-200 hover:scale-105"
              onClick={solicitarSaque}
            >
              📤 Solicitar Saque
            </button>
          </div>
          
          <div id="refArea" className="my-4 p-4 bg-black/30 rounded-lg inline-block">
            <p className="text-[#00ffea] mb-2">🔗 Seu link de referência: <br />
              <code id="refLink" className="bg-[#1a1a1a] p-1 rounded text-xs block mt-1 overflow-auto max-w-xs"></code>
            </p>
            <p className="text-[#00ffea] mb-2">👥 Indicações: <span id="refCount">{refCount}</span> | Comissão Total: <span id="refComissao">{refComissao}</span> BTC</p>
          </div>
          
          <br/>
          
          <button 
            className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mt-2"
            onClick={spin}
          >
            🎰 Girar Agora
          </button>
          
          {result && (
            <div className="mt-5 text-lg text-[#f5c518]">
              <p>🎲 Número sorteado: <strong>{result.number}</strong></p>
              <p>🏆 Prêmio: <strong>{result.prize}</strong></p>
            </div>
          )}
          
          <div className="mt-8">
            <button 
              className="bg-[#ff00c8] text-white px-8 py-3 rounded-full text-base cursor-pointer shadow-[0_0_8px_#ff00c8,0_0_20px_#00ffea] transition-transform duration-200 hover:scale-105 mt-2"
              onClick={abrirAdmin}
            >
              🔐 Painel do Admin
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LuckySpinPage;